import React, { useRef, useState } from 'react';

const VideoPlayer = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayPause = () => {
        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    return (
        <div>
            <video ref={videoRef} width="640" height="360" controls>
                <source src="https://sysapi.ege.edu.tr/Files/KKTC_soru_yazim_kilavuzu.mp4" type="video/mp4" />
                Tarayıcınız bu videoyu oynatmayı desteklemiyor.
            </video>
            {/*<button onClick={handlePlayPause}>
                {isPlaying ? 'Durdur' : 'Oynat'}
            </button>*/}
        </div>
    );
};

export default VideoPlayer;
